var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6666C8.41287 14.6671 8.81564 14.539 9.15233 14.3C9.48902 14.0611 9.74289 13.7232 9.87867 13.3333H6.12133C6.25711 13.7232 6.51099 14.0611 6.84767 14.3C7.18436 14.539 7.58713 14.6671 8 14.6666ZM12.6667 9.72392V6.66659C12.6667 4.52192 11.21 2.71525 9.23667 2.17192C9.04133 1.67992 8.564 1.33325 8 1.33325C7.436 1.33325 6.95867 1.67992 6.76333 2.17192C4.79 2.71592 3.33333 4.52192 3.33333 6.66659V9.72392L2.19533 10.8619C2.13331 10.9237 2.08411 10.9972 2.05059 11.0781C2.01707 11.159 1.99987 11.2457 2 11.3333V11.9999C2 12.1767 2.07024 12.3463 2.19526 12.4713C2.32029 12.5963 2.48986 12.6666 2.66667 12.6666H13.3333C13.5101 12.6666 13.6797 12.5963 13.8047 12.4713C13.9298 12.3463 14 12.1767 14 11.9999V11.3333C14.0001 11.2457 13.9829 11.159 13.9494 11.0781C13.9159 10.9972 13.8667 10.9237 13.8047 10.8619L12.6667 9.72392Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6dd5e42c93ef97906c353b6f82db3231.svg";
export { ForwardRef as ReactComponent };